<template>
  <div
    v-if="this.$store.getters.settings.license.active"
    class="p-6 flex-grow-1 container-p-y"
  >
    <div class="row">
      <div class="col-md-6 col-12 mb-4">
        <div class="card">
          <div class="card-body control-options-container">
            <div class="mb-7">
              <label class="form-label">{{ $t("batches.designer") }}</label>
              <div class="btn-group w-100">
                <button
                  :class="[
                    'btn',
                    activeTab === 'simple'
                      ? 'btn-primary'
                      : 'btn-outline-primary',
                  ]"
                  @click="
                    activeTab = 'simple';
                    elements.designer = 'basic';
                  "
                >
                  {{ $t("batches.basic_designer") }}
                </button>
                <button
                  :class="[
                    'btn',
                    activeTab === 'advanced'
                      ? 'btn-primary'
                      : 'btn-outline-primary',
                  ]"
                  @click="
                    activeTab = 'advanced';
                    elements.designer = 'advanced';
                  "
                >
                  {{ $t("batches.advanced_designer") }}
                </button>
              </div>
            </div>
            <div class="">
              <div>
                <div class="col-12">
                  <label class="form-label">{{
                    $t("batches.saved_designs")
                  }}</label>
                  <div class="input-group">
                    <select
                      class="form-select"
                      v-model="design_id"
                      @change="selectDesign"
                      aria-label="Example select with button addon"
                    >
                      <option value="-1">
                        {{ $t("batches.new_design") }}
                      </option>
                      <option
                        v-for="design in designs"
                        v-bind:key="design.id"
                        :value="design.id"
                      >
                        {{ design.name }}
                      </option>
                    </select>
                    <button
                      class="btn btn-outline-primary"
                      @click="saveDesignDialog"
                      type="button"
                    >
                      {{ $t("batches.save_design") }}
                    </button>
                  </div>
                </div>
                <div class="row" v-if="elements.designer == 'advanced'">
                  <div class="col-8 mt-4">
                    <label
                      for="upload"
                      class="btn btn-primary w-100"
                      tabindex="0"
                    >
                      <span class="d-none d-sm-block">{{
                        $t("batches.upload_background")
                      }}</span>
                      <span v-if="cards_count == 1" class="mx-1"
                        >(1000px X 291px)</span
                      >
                      <span v-else-if="cards_count == 2" class="mx-1"
                        >(750px X 291px)</span
                      >
                      <span v-else-if="cards_count == 3" class="mx-1"
                        >(500px X 291px)</span
                      >
                      <span v-else-if="cards_count == 4" class="mx-1"
                        >(250px X 291px)</span
                      >
                      <span v-else-if="cards_count == 5" class="mx-1"
                        >(125px X 291px)</span
                      >
                      <span v-else-if="cards_count == 6" class="mx-1"
                        >(75px X 291px)</span
                      >
                      <i class="ti ti-upload d-block d-sm-none"></i>
                      <input
                        type="file"
                        id="upload"
                        class="account-file-input"
                        ref="imageFile"
                        @change="selectBackground"
                        hidden
                        accept="image/png, image/jpeg"
                      />
                    </label>
                  </div>
                  <div class="col-4 mt-4">
                    <label
                      @click="
                        background = null;
                        background_file = null;
                      "
                      class="btn btn-secondary w-100"
                      tabindex="0"
                    >
                      <span class="d-none d-sm-block">{{
                        $t("batches.remove_background")
                      }}</span>
                    </label>
                  </div>
                </div>
                <div class="scroll-container mt-5">
                  <div class="row">
                    <PrintDesigner
                      :field="elements.username"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.password"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.network"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.logo"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.qr_code"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.price"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.speed"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.expiration"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.quota"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.profile"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.sessions"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.phone_number"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                    <PrintDesigner
                      :field="elements.status_url"
                      :designer="elements.designer"
                      :toggle-field="toggleField"
                    />
                  </div>
                </div>
              </div>

              <!-- <div v-if="activeTab === 'advanced'">
                <div class="col-12">
                  <label class="form-label">{{
                    $t("batches.saved_designs")
                  }}</label>
                  <div class="input-group">
                    <select
                      v-model="design_id"
                      @change="selectDesign"
                      class="form-select"
                      id="inputGroupSelect04"
                      aria-label="Example select with button addon"
                    >
                      <option value="-1">
                        {{ $t("batches.new_design") }}
                      </option>
                      <option
                        v-for="design in designs"
                        v-bind:key="design.id"
                        :value="design.id"
                      >
                        {{ design.name }}
                      </option>
                    </select>
                    <button class="btn btn-outline-primary" type="button">
                      {{ $t("batches.save_design") }}
                    </button>
                  </div>
                </div>
                <div class="scroll-container mt-5">
                  <div class="row">
                    <div class="col-8 mb-4">
                      <label
                        for="upload"
                        class="btn btn-primary w-100"
                        tabindex="0"
                      >
                        <span class="d-none d-sm-block">{{
                          $t("batches.upload_background")
                        }}</span>
                        <i class="ti ti-upload d-block d-sm-none"></i>
                        <input
                          type="file"
                          id="upload"
                          class="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                        />
                      </label>
                    </div>
                    <div class="col-4 mb-4">
                      <label class="btn btn-secondary w-100" tabindex="0">
                        <span class="d-none d-sm-block">{{
                          $t("batches.remove_background")
                        }}</span>
                      </label>
                    </div>
                    <div
                      v-for="(field, index) in fields"
                      :key="index"
                      class="col-xl-6 col-12 mt-3"
                    >
                      <div
                        class="border rounded p-5 mb-5 card-box"
                        :class="field.active ? 'border-primary' : ''"
                      >
                        <div
                          class="d-flex align-items-center justify-content-between mb-4"
                        >
                          <div class="d-flex align-items-center">
                            <div class="avatar avatar-sm flex-shrink-0 me-2">
                              <span
                                class="avatar-initial rounded"
                                :class="
                                  field.active
                                    ? 'bg-label-primary'
                                    : 'bg-label-secondary'
                                "
                              >
                                <i :class="field.icon"></i>
                              </span>
                            </div>
                            <div>
                              <h6
                                class="mb-0 text-nowrap"
                                :class="
                                  field.active
                                    ? 'text-primary'
                                    : 'text-secondary'
                                "
                              >
                                {{ field.label }}
                              </h6>
                            </div>
                          </div>
                          <div class="me-7">
                            <label class="switch switch-square">
                              <input
                                type="checkbox"
                                class="switch-input"
                                v-model="field.active"
                                @change="toggleField(field)"
                              />
                              <span class="switch-toggle-slider">
                                <span class="switch-on"
                                  ><i class="ti ti-check"></i
                                ></span>
                                <span class="switch-off"
                                  ><i class="ti ti-x"></i
                                ></span>
                              </span>
                            </label>
                          </div>
                        </div>

                        <div class="mt-4">
                          <label class="form-label mb-2">{{
                            $t("batches.position")
                          }}</label>

                          <div class="d-flex align-items-center mb-2">
                            <span class="me-2 small">U</span>
                            <input
                              type="range"
                              min="0"
                              max="100"
                              v-model="field.position.up"
                              class="form-range"
                              :disabled="!field.active"
                            />
                            <span class="ms-2 small">D</span>
                          </div>

                          <div class="d-flex align-items-center mb-2">
                            <span class="me-2 small">L</span>
                            <input
                              type="range"
                              min="0"
                              max="100"
                              v-model="field.position.left"
                              class="form-range"
                              :disabled="!field.active"
                            />
                            <span class="ms-2 small">R</span>
                          </div>

                          <div class="d-flex align-items-center mb-2">
                            <span class="me-2 small">S</span>
                            <input
                              type="range"
                              min="0"
                              max="100"
                              v-model="field.position.scale"
                              class="form-range"
                              :disabled="!field.active"
                            />
                            <span class="ms-2 small">L</span>
                          </div>

                          <label class="form-label">{{
                            $t("batches.color")
                          }}</label>
                          <input
                            class="form-control"
                            type="color"
                            v-model="field.color"
                            :disabled="!field.active"
                          />
                        </div>

                        <div v-if="field.label === 'QR Code'" class="mt-4">
                          <label class="form-label">URL</label>
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Enter link for QR code"
                            v-model="field.link"
                            :disabled="!field.active"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12" dir="ltr">
        <div
          class="card mb-4 d-flex justify-content-center align-items-center p-5"
        >
          <div
            id="basic_card_preview"
            v-if="cards_chunks.length > 0 && elements.designer == 'basic'"
            class="flex flex-col justify-center items-center border-t-2 border-b-2 border-r border-l rounded-3xl text-sm relative"
            :class="{
              times1: cards_count == 1,
              times2: cards_count == 2,
              times3: cards_count == 3,
              times4: cards_count == 4,
              times5: cards_count == 5,
              times6: cards_count == 6,
            }"
            style="height: 3.85cm; font-size: 9pt;"
            :style="
              `border-color: ${elements.colors.border}; background-color: ${elements.colors.background};background-image: url(${this.background});background-repeat: no-repeat;background-position: center;background-size: cover;`
            "
          >
            <div
              class="flex w-full justify-between mt-2"
              :style="`color: ${elements.colors.text_big}`"
            >
              <div
                v-if="elements.qr_code.visible && elements.qr_code"
                class="flex flex-col w-full justify-center items-center"
              >
                <div>
                  <qrcode-vue
                    :foreground="elements.qr_code.color"
                    :value="
                      `http://${elements.qr_code.url}/login?username=${cards_chunks[0][0].username}&password=${cards_chunks[0][0].password}`
                    "
                    :size="60"
                    :render-as="'svg'"
                    level="L"
                  />
                </div>
              </div>
              <div class="flex flex-col w-full justify-center items-center">
                <div>
                  {{ $t("cards.username") }}
                </div>
                <div class="mt-2">{{ $t("cards.password") }}</div>
              </div>

              <div class="flex flex-col w-full justify-center items-center">
                <div
                  class="w-full text-center rounded-full border"
                  :style="
                    `background-color: ${elements.colors.input}; border-color: ${elements.colors.border}`
                  "
                >
                  {{ cards_chunks[0][0].username }}
                </div>
                <div
                  class="w-full text-center rounded-full border mt-2"
                  :style="
                    `background-color: ${elements.colors.input}; border-color: ${elements.colors.border}`
                  "
                >
                  {{ cards_chunks[0][0].password }}
                </div>
              </div>
              <div
                v-if="elements.logo.visible || elements.network.visible"
                class="flex flex-col w-full justify-center items-center"
              >
                <div v-if="elements.logo.visible">
                  <img
                    :src="server_url + settings.network_logo"
                    alt=""
                    class="h-14 mb-1"
                  />
                </div>
                <div v-if="elements.network.visible">
                  {{ settings.network_name }}
                </div>
              </div>
            </div>
            <div
              class="flex flex-wrap w-full gap-x-1 px-2"
              style="font-size: 6pt"
              :style="`color: ${elements.colors.text_small}`"
            >
              <div
                v-if="elements.price.visible"
                class="rounded-full flex items-center justify-center m-1 flex-1"
                :style="`background-color: ${elements.colors.boxes}`"
              >
                <!-- <div>{{ $t("batches.speed") }}</div> -->
                <div>
                  {{ cards_chunks[0][0].batch.price + " " + settings.currency }}
                </div>
              </div>
              <div
                v-if="elements.speed.visible"
                class="rounded-full flex items-center justify-center m-1 flex-1"
                :style="`background-color: ${elements.colors.boxes}`"
              >
                <!-- <div>{{ $t("batches.speed") }}</div> -->
                <div>
                  {{
                    calculateSpeed(cards_chunks[0][0].profile.download_rate_kb)
                  }}
                </div>
              </div>
              <div
                v-if="elements.expiration.visible"
                class="rounded-full flex items-center justify-center m-1 flex-1"
                :style="`background-color: ${elements.colors.boxes}`"
              >
                <!-- <div>{{ $t("batches.duration") }}</div> -->
                <div>
                  {{
                    cards_chunks[0][0].profile.expiration_value +
                      calculateUnit(cards_chunks[0][0].profile.expiration_unit)
                  }}
                </div>
              </div>
              <div
                v-if="elements.quota.visible"
                class="rounded-full flex items-center justify-center flex-1 m-1"
                :style="`background-color: ${elements.colors.boxes}`"
              >
                <!-- <div>{{ $t("batches.quota") }}</div> -->
                <div>
                  {{
                    calculateQuota(
                      cards_chunks[0][0].profile.traffic_limit_value_mb,
                    )
                  }}
                </div>
              </div>
              <div
                v-if="elements.profile.visible"
                class="rounded-full flex items-center justify-center flex-1 m-1"
                :style="`background-color: ${elements.colors.boxes}`"
              >
                <!-- <div>{{ $t("batches.quota") }}</div> -->
                <div>
                  {{ cards_chunks[0][0].profile.name }}
                </div>
              </div>
              <div
                v-if="elements.sessions.visible"
                class="rounded-full flex items-center justify-center flex-1 m-1"
                :style="`background-color: ${elements.colors.boxes}`"
              >
                <!-- <div>{{ $t("batches.quota") }}</div> -->
                <div>
                  {{
                    cards_chunks[0][0].allowed_sessions +
                      " " +
                      $t("control.device")
                  }}
                </div>
              </div>
            </div>
            <div
              v-if="elements.phone_number.visible"
              class="w-full flex justify-center gap-2"
            >
              <div class="font-bold">{{ $t("settings.phone_number") }}:</div>
              <div>{{ settings.phone_number }}</div>
            </div>
            <div
              v-if="elements.status_url.visible"
              class="w-full flex justify-center gap-2"
            >
              <div class="font-bold">{{ $t("settings.status_url") }}:</div>
              <div>{{ settings.status_url }}</div>
            </div>
          </div>
          <!-- <div
            v-if="cards_chunks.length > 0 && elements.designer == 'basic'"
            class="d-flex align-items-center"
            style="height: 5cm; font-size: 9pt"
            :class="{
              times1: cards_count == 1,
              times2: cards_count == 2,
              times3: cards_count == 3,
            }"
            :style="
              `background-color: ${elements.colors.background};background-image: url(${this.background});background-repeat: no-repeat;background-position: center;background-size: cover; border-radius: 10px; border: 3px solid ${elements.colors.border} !important;`
            "
          >
            <div class="row p-4" :style="`color: ${elements.colors.text_big}`">
              <div
                v-if="elements.logo.visible || elements.network.visible"
                class="col-3 d-flex justify-content-start flex-column "
              >
                <div
                  class="d-flex justify-content-center flex-column items-center"
                >
                  <img
                    v-if="elements.logo.visible"
                    :src="server_url + settings.network_logo"
                    style="height: 60px;"
                  />
                  <h4
                    v-if="elements.network.visible"
                    :style="`color: ${elements.network.color};`"
                  >
                    {{ settings.network_name }}
                  </h4>
                </div>
              </div>
              <div
                class="flex-1 w-full d-flex justify-content-center flex-column"
                :style="`color: ${elements.colors.text_big} !important;`"
              >
                <div
                  class="alert alert-solid-primary d-flex align-items-center h-px-40 p-1 text-center"
                  role="alert"
                  :style="`background-color: ${elements.colors.input};`"
                >
                  <span
                    v-if="elements.username.visible"
                    class="alert-icon rounded w-px-100"
                  >
                    {{ $t("cards.username") }}
                  </span>
                  <div
                    class="flex-1"
                    :style="`color: ${elements.colors.text_big}`"
                  >
                    {{ cards_chunks[0][0].username }}
                  </div>
                </div>
                <div
                  class="alert alert-solid-primary d-flex align-items-center h-px-40 p-1 text-center"
                  role="alert"
                  :style="`background-color: ${elements.colors.input};`"
                >
                  <span
                    v-if="elements.password.visible"
                    class="alert-icon rounded w-px-100"
                  >
                    {{ $t("cards.password") }}
                  </span>
                  <div
                    class="flex-1"
                    :style="`color: ${elements.colors.text_big}`"
                  >
                    {{ cards_chunks[0][0].password }}
                  </div>
                </div>
              </div>
              <div
                class="col-2 d-flex justify-content-center items-center"
                v-if="elements.qr_code.visible && elements.qr_code"
              >
                <div>
                  <qrcode-vue
                    :value="
                      `http://${elements.qr_code.url}/login?username=${cards_chunks[0][0].username}&password=${cards_chunks[0][0].password}`
                    "
                    :size="60"
                    :render-as="'svg'"
                    level="L"
                  />
                </div>
              </div>
              <div class="row">
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.price.visible"
                  :style="``"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{
                      cards_chunks[0][0].batch.price + " " + settings.currency
                    }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.speed.visible"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{
                      calculateSpeed(
                        cards_chunks[0][0].profile.download_rate_kb
                      )
                    }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.expiration.visible"
                  :style="`color: ${elements.colors.text_small}`"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{
                      cards_chunks[0][0].profile.expiration_value +
                        calculateUnit(
                          cards_chunks[0][0].profile.expiration_unit
                        )
                    }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.quota.visible"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{
                      calculateQuota(
                        cards_chunks[0][0].profile.traffic_limit_value_mb
                      )
                    }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.profile.visible"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{ cards_chunks[0][0].profile.name }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.sessions.visible"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{
                      cards_chunks[0][0].allowed_sessions +
                        " " +
                        $t("control.device")
                    }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.phone_number.visible"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{ settings.phone_number }}
                  </div>
                </div>
                <div
                  class="net-card-d col d-flex justify-content-center flex-column"
                  v-if="elements.status_url.visible"
                >
                  <div
                    class="alert alert-solid-info justify-content-center d-flex align-items-center mb-1"
                    role="alert"
                    :style="
                      `background-color: ${elements.colors.boxes};color: ${elements.colors.text_small} !important;`
                    "
                  >
                    {{ settings.status_url }}
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div
            id="advanced_card_preview"
            v-if="cards_chunks.length > 0 && elements.designer == 'advanced'"
            class="flex flex-col text-sm relative font-sans mt-4 border"
            :class="{
              times1: cards_count == 1,
              times2: cards_count == 2,
              times3: cards_count == 3,
              times4: cards_count == 4,
              times5: cards_count == 5,
              times6: cards_count == 6,
            }"
            :style="
              `background-image: url(${this.background});background-repeat: no-repeat;background-position: center;background-size: cover;`
            "
          >
            <div
              v-if="elements.username.visible"
              class="absolute"
              :style="
                `top: ${elements.username.y}%;left: ${elements.username.x}%; font-size: ${elements.username.size}px; color: ${elements.username.color}`
              "
            >
              {{ cards_chunks[0][0].username }}
            </div>
            <div
              v-if="elements.password.visible"
              class="absolute"
              :style="
                `top: ${elements.password.y}%;left: ${elements.password.x}%; font-size: ${elements.password.size}px; color: ${elements.password.color}`
              "
            >
              {{ cards_chunks[0][0].password }}
            </div>
            <div
              v-if="elements.network.visible"
              class="absolute"
              :style="
                `top: ${elements.network.y}%;left: ${elements.network.x}%; font-size: ${elements.network.size}px; color: ${elements.network.color}`
              "
            >
              {{ settings.network_name }}
            </div>
            <img
              v-if="elements.logo.visible"
              :style="
                `top: ${elements.logo.y}%;left: ${elements.logo.x}%; height:${elements.logo.size}mm`
              "
              :src="server_url + settings.network_logo"
              alt=""
              class="absolute mb-1"
            />
            <div
              v-if="elements.price.visible"
              class="absolute"
              :style="
                `top: ${elements.price.y}%;left: ${elements.price.x}%; font-size: ${elements.price.size}px; color: ${elements.price.color}`
              "
            >
              {{ cards_chunks[0][0].batch.price + " " + settings.currency }}
            </div>
            <div
              v-if="elements.speed.visible"
              class="absolute"
              :style="
                `top: ${elements.speed.y}%;left: ${elements.speed.x}%; font-size: ${elements.speed.size}px; color: ${elements.speed.color}`
              "
            >
              {{ calculateSpeed(cards_chunks[0][0].profile.download_rate_kb) }}
            </div>
            <div
              v-if="elements.expiration.visible"
              class="absolute"
              :style="
                `top: ${elements.expiration.y}%;left: ${elements.expiration.x}%; font-size: ${elements.expiration.size}px; color: ${elements.expiration.color}`
              "
            >
              {{
                cards_chunks[0][0].profile.expiration_value +
                  calculateUnit(cards_chunks[0][0].profile.expiration_unit)
              }}
            </div>
            <div
              v-if="elements.quota.visible"
              class="absolute"
              :style="
                `top: ${elements.quota.y}%;left: ${elements.quota.x}%; font-size: ${elements.quota.size}px; color: ${elements.quota.color}`
              "
            >
              {{
                calculateQuota(
                  cards_chunks[0][0].profile.traffic_limit_value_mb,
                )
              }}
            </div>
            <div
              v-if="elements.profile.visible"
              class="absolute"
              :style="
                `top: ${elements.profile.y}%;left: ${elements.profile.x}%; font-size: ${elements.profile.size}px; color: ${elements.profile.color}`
              "
            >
              {{ cards_chunks[0][0].profile.name }}
            </div>
            <div
              v-if="elements.sessions.visible"
              class="absolute"
              :style="
                `top: ${elements.sessions.y}%;left: ${elements.sessions.x}%; font-size: ${elements.sessions.size}px; color: ${elements.sessions.color}`
              "
            >
              {{ cards_chunks[0][0].allowed_sessions }}
            </div>
            <div
              v-if="elements.phone_number.visible"
              class="absolute"
              :style="
                `top: ${elements.phone_number.y}%;left: ${elements.phone_number.x}%; font-size: ${elements.phone_number.size}px; color: ${elements.phone_number.color}`
              "
            >
              {{ settings.phone_number }}
            </div>
            <div
              v-if="elements.status_url.visible"
              class="absolute"
              :style="
                `top: ${elements.status_url.y}%;left: ${elements.status_url.x}%; font-size: ${elements.status_url.size}px; color: ${elements.status_url.color}`
              "
            >
              {{ settings.status_url }}
            </div>
            <div
              v-if="elements.qr_code.visible && elements.qr_code"
              class="absolute"
              :style="
                `top: ${elements.qr_code.y}%;left: ${elements.qr_code.x}%; font-size: ${elements.qr_code.size}px;`
              "
            >
              <qrcode-vue
                :foreground="elements.qr_code.color"
                :value="
                  `http://${elements.qr_code.url}/login?username=${cards_chunks[0][0].username}&password=${cards_chunks[0][0].password}`
                "
                :size="elements.qr_code.size"
                :render-as="'svg'"
                level="L"
              />
            </div>
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-body control-options-container">
            <!-- Cards per Row Options -->
            <div class="mb-5">
              <label class="form-label">{{
                $t("batches.cards_count_row")
              }}</label>
              <div class="btn-group w-100" dir="rtl">
                <button
                  class="btn"
                  :class="{
                    'btn-primary': selectedCards === 1,
                    'btn-outline-primary': selectedCards !== 1,
                  }"
                  @click="setCards(1)"
                >
                  1
                </button>
                <button
                  class="btn"
                  :class="{
                    'btn-primary': selectedCards === 2,
                    'btn-outline-primary': selectedCards !== 2,
                  }"
                  @click="setCards(2)"
                >
                  2
                </button>
                <button
                  class="btn"
                  :class="{
                    'btn-primary': selectedCards === 3,
                    'btn-outline-primary': selectedCards !== 3,
                  }"
                  @click="setCards(3)"
                >
                  3
                </button>
                <button
                  class="btn"
                  :class="{
                    'btn-primary': selectedCards === 4,
                    'btn-outline-primary': selectedCards !== 4,
                  }"
                  @click="setCards(4)"
                >
                  4
                </button>
                <button
                  class="btn"
                  :class="{
                    'btn-primary': selectedCards === 5,
                    'btn-outline-primary': selectedCards !== 5,
                  }"
                  @click="setCards(5)"
                >
                  5
                </button>
                <button
                  class="btn"
                  :class="{
                    'btn-primary': selectedCards === 6,
                    'btn-outline-primary': selectedCards !== 6,
                  }"
                  @click="setCards(6)"
                >
                  6
                </button>
              </div>
            </div>

            <!-- Color Pickers -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">{{
                  $t("batches.color_border")
                }}</label>
                <input
                  class="form-control"
                  type="color"
                  value="#666EE8"
                  v-model="elements.colors.border"
                  id="html5-color-border"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{
                  $t("batches.color_background")
                }}</label>
                <input
                  class="form-control"
                  type="color"
                  value="#666EE8"
                  v-model="elements.colors.background"
                  id="html5-color-background"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{
                  $t("batches.color_text_big")
                }}</label>
                <input
                  class="form-control"
                  type="color"
                  value="#666EE8"
                  v-model="elements.colors.text_big"
                  id="html5-color-primary-text"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{
                  $t("batches.color_input")
                }}</label>
                <input
                  class="form-control"
                  type="color"
                  value="#666EE8"
                  v-model="elements.colors.input"
                  id="html5-color-primary-boxes"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{
                  $t("batches.color_text_small")
                }}</label>
                <input
                  class="form-control"
                  type="color"
                  value="#666EE8"
                  v-model="elements.colors.text_small"
                  id="html5-color-secondary-text"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{
                  $t("batches.color_boxes")
                }}</label>
                <input
                  class="form-control"
                  type="color"
                  value="#666EE8"
                  v-model="elements.colors.boxes"
                  id="html5-color-secondary-boxes"
                />
              </div>
            </div>

            <div class="d-flex justify-content-center mt-4">
              <button class="btn btn-primary w-100" @click="print_element">
                <i class="ti ti-printer me-2"></i> {{ $t("batches.print") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="print_page" class="noScreen">
        <div>
          <div>
            <div v-for="cards in cards_chunks" v-bind:key="cards[0]">
              <div
                class="grid gap-y-2 gap-x-1 text-center"
                style="page-break-after: always"
                :class="{
                  'grid-cols-1': cards_count == 1,
                  'grid-cols-2': cards_count == 2,
                  'grid-cols-3': cards_count == 3,
                  'grid-cols-4': cards_count == 4,
                  'grid-cols-5': cards_count == 5,
                  'grid-cols-6': cards_count == 6,
                }"
              >
                <div
                  v-if="elements.designer == 'advanced'"
                  v-for="card in cards"
                  v-bind:key="card.id"
                  class="flex flex-col text-sm relative font-sans bg-white"
                  style="height: 3.85cm; font-size: 9pt"
                  :style="
                    `background-image: url(${this.background});background-repeat: no-repeat;background-position: center;background-size: cover;`
                  "
                >
                  <div
                    v-if="elements.username.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.username.y}%;left: ${elements.username.x}%; font-size: ${elements.username.size}px; color: ${elements.username.color}`
                    "
                  >
                    {{ card.username }}
                  </div>
                  <div
                    v-if="elements.password.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.password.y}%;left: ${elements.password.x}%; font-size: ${elements.password.size}px; color: ${elements.password.color}`
                    "
                  >
                    {{ card.password }}
                  </div>
                  <div
                    v-if="elements.network.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.network.y}%;left: ${elements.network.x}%; font-size: ${elements.network.size}px; color: ${elements.network.color}`
                    "
                  >
                    {{ settings.network_name }}
                  </div>
                  <img
                    v-if="elements.logo.visible"
                    :style="
                      `top: ${elements.logo.y}%;left: ${elements.logo.x}%; height:${elements.logo.size}mm`
                    "
                    :src="server_url + settings.network_logo"
                    alt=""
                    class="absolute mb-1"
                  />
                  <div
                    v-if="elements.price.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.price.y}%;left: ${elements.price.x}%; font-size: ${elements.price.size}px; color: ${elements.price.color}`
                    "
                  >
                    {{ card.batch.price + " " + settings.currency }}
                  </div>
                  <div
                    v-if="elements.speed.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.speed.y}%;left: ${elements.speed.x}%; font-size: ${elements.speed.size}px; color: ${elements.speed.color}`
                    "
                  >
                    {{ calculateSpeed(card.profile.download_rate_kb) }}
                  </div>
                  <div
                    v-if="elements.expiration.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.expiration.y}%;left: ${elements.expiration.x}%; font-size: ${elements.expiration.size}px; color: ${elements.expiration.color}`
                    "
                  >
                    {{
                      card.profile.expiration_value +
                        calculateUnit(card.profile.expiration_unit)
                    }}
                  </div>
                  <div
                    v-if="elements.quota.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.quota.y}%;left: ${elements.quota.x}%; font-size: ${elements.quota.size}px; color: ${elements.quota.color}`
                    "
                  >
                    {{ calculateQuota(card.profile.traffic_limit_value_mb) }}
                  </div>
                  <div
                    v-if="elements.profile.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.profile.y}%;left: ${elements.profile.x}%; font-size: ${elements.profile.size}px; color: ${elements.profile.color}`
                    "
                  >
                    {{ card.profile.name }}
                  </div>
                  <div
                    v-if="elements.sessions.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.sessions.y}%;left: ${elements.sessions.x}%; font-size: ${elements.sessions.size}px; color: ${elements.sessions.color}`
                    "
                  >
                    {{ card.allowed_sessions }}
                  </div>
                  <div
                    v-if="elements.phone_number.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.phone_number.y}%;left: ${elements.phone_number.x}%; font-size: ${elements.phone_number.size}px; color: ${elements.phone_number.color}`
                    "
                  >
                    {{ settings.phone_number }}
                  </div>
                  <div
                    v-if="elements.status_url.visible"
                    class="absolute"
                    :style="
                      `top: ${elements.status_url.y}%;left: ${elements.status_url.x}%; font-size: ${elements.status_url.size}px; color: ${elements.status_url.color}`
                    "
                  >
                    {{ settings.status_url }}
                  </div>
                  <div
                    v-if="elements.qr_code.visible && elements.qr_code"
                    class="absolute"
                    :style="
                      `top: ${elements.qr_code.y}%;left: ${elements.qr_code.x}%; font-size: ${elements.qr_code.size}px;`
                    "
                  >
                    <qrcode-vue
                      :value="
                        `http://${elements.qr_code.url}/login?username=${card.username}&password=${card.password}`
                      "
                      :foreground="elements.qr_code.color"
                      :size="elements.qr_code.size"
                      :render-as="'svg'"
                      level="L"
                    />
                  </div>
                </div>
                <div
                  v-if="elements.designer == 'basic'"
                  v-for="card in cards"
                  v-bind:key="card.id"
                  class="flex flex-col justify-center items-center border-t-2 border-b-2 border-r border-l rounded-3xl text-sm relative"
                  style="height: 3.85cm; font-size: 9pt"
                  :style="
                    `border-color: ${elements.colors.border}; background-color: ${elements.colors.background};background-image: url(${this.background});background-repeat: no-repeat;background-position: center;background-size: cover;`
                  "
                >
                  <div
                    class="flex w-full justify-between mt-2"
                    :style="`color: ${elements.colors.text_big}`"
                  >
                    <div
                      v-if="elements.qr_code.visible && elements.qr_code"
                      class="flex flex-col w-full justify-center items-center"
                    >
                      <div>
                        <qrcode-vue
                          :value="
                            `http://${elements.qr_code.url}/login?username=${card.username}&password=${card.password}`
                          "
                          :foreground="elements.qr_code.color"
                          :size="60"
                          :render-as="'svg'"
                          level="L"
                        />
                      </div>
                    </div>
                    <div
                      class="flex flex-col w-full justify-center items-center"
                    >
                      <div>
                        {{ $t("cards.username") }}
                      </div>
                      <div class="mt-2">{{ $t("cards.password") }}</div>
                    </div>
                    <div
                      class="flex flex-col w-full justify-center items-center"
                    >
                      <div
                        class="w-full text-center rounded-full border"
                        :style="
                          `background-color: ${elements.colors.input}; border-color: ${elements.colors.border}`
                        "
                      >
                        {{ card.username }}
                      </div>
                      <div
                        class="w-full text-center rounded-full border mt-2"
                        :style="
                          `background-color: ${elements.colors.input}; border-color: ${elements.colors.border}`
                        "
                      >
                        {{ card.password }}
                      </div>
                    </div>
                    <div
                      v-if="elements.logo.visible || elements.network.visible"
                      class="flex flex-col w-full justify-center items-center"
                    >
                      <div v-if="elements.logo.visible">
                        <img
                          :src="server_url + settings.network_logo"
                          alt=""
                          class="h-14 mb-1"
                        />
                      </div>
                      <div v-if="elements.network.visible">
                        {{ settings.network_name }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-wrap w-full gap-x-1 px-2"
                    style="font-size: 6pt"
                    :style="`color: ${elements.colors.text_small}`"
                  >
                    <div
                      v-if="elements.price.visible"
                      class="rounded-full flex items-center justify-center flex-1 m-1"
                      :style="`background-color: ${elements.colors.boxes}`"
                    >
                      <!-- <div>{{ $t("batches.speed") }}</div> -->
                      <div>
                        {{ card.batch.price + " " + settings.currency }}
                      </div>
                    </div>
                    <div
                      v-if="elements.speed.visible"
                      class="rounded-full flex items-center justify-center flex-1 m-1"
                      :style="`background-color: ${elements.colors.boxes}`"
                    >
                      <!-- <div>{{ $t("batches.speed") }}</div> -->
                      <div>
                        {{ calculateSpeed(card.profile.download_rate_kb) }}
                      </div>
                    </div>
                    <div
                      v-if="elements.expiration.visible"
                      class="rounded-full flex items-center justify-center flex-1 m-1"
                      :style="`background-color: ${elements.colors.boxes}`"
                    >
                      <!-- <div>{{ $t("batches.duration") }}</div> -->
                      <div>
                        {{
                          card.profile.expiration_value +
                            calculateUnit(card.profile.expiration_unit)
                        }}
                      </div>
                    </div>
                    <div
                      v-if="elements.quota.visible"
                      class="rounded-full flex items-center justify-center flex-1 m-1"
                      :style="`background-color: ${elements.colors.boxes}`"
                    >
                      <!-- <div>{{ $t("batches.quota") }}</div> -->
                      <div>
                        {{
                          calculateQuota(card.profile.traffic_limit_value_mb)
                        }}
                      </div>
                    </div>
                    <div
                      v-if="elements.profile.visible"
                      class="rounded-full flex items-center justify-center flex-1 m-1"
                      :style="`background-color: ${elements.colors.boxes}`"
                    >
                      <!-- <div>{{ $t("batches.quota") }}</div> -->
                      <div>
                        {{ card.profile.name }}
                      </div>
                    </div>
                    <div
                      v-if="elements.sessions.visible"
                      class="rounded-full flex items-center justify-center flex-1 m-1"
                      :style="`background-color: ${elements.colors.boxes}`"
                    >
                      <!-- <div>{{ $t("batches.quota") }}</div> -->
                      <div>
                        {{ card.allowed_sessions + " " + $t("control.device") }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="elements.phone_number.visible"
                    class="w-full flex justify-center gap-2"
                  >
                    <div class="font-bold">
                      {{ $t("settings.phone_number") }}:
                    </div>
                    <div>{{ settings.phone_number }}</div>
                  </div>
                  <div
                    v-if="elements.status_url.visible"
                    class="w-full flex justify-center gap-2"
                  >
                    <div class="font-bold">
                      {{ $t("settings.status_url") }}:
                    </div>
                    <div>{{ settings.status_url }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import PrintDesigner from "../components/PrintDesigner.vue";
import { print_element } from "../global_constants";
export default {
  name: "FieldsCards",
  components: {
    QrcodeVue,
    PrintDesigner,
  },
  data() {
    return {
      activeTab: "simple",
      selectedCards: 2,
      fields: [
        {
          label: this.$t("cards.username"),
          icon: "ti ti-user",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("cards.password"),
          icon: "ti ti-lock",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.network"),
          icon: "ti ti-wifi",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.price"),
          icon: "ti ti-currency-dollar",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.speed"),
          icon: "ti ti-rocket",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.duration"),
          icon: "ti ti-hourglass",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.quota"),
          icon: "ti ti-chart-pie",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.profile"),
          icon: "ti ti-id-badge",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.sessions"),
          icon: "ti ti-device-laptop",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("batches.logo"),
          icon: "ti ti-photo",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("settings.phone_number"),
          icon: "ti ti-phone",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: this.$t("settings.status_url"),
          icon: "ti ti-link",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          position: { up: 50, left: 50, scale: 100 },
        },
        {
          label: "QR Code",
          icon: "ti ti-qrcode",
          active: true,
          color: "#685dd8",
          originalColor: "#685dd8",
          link: "",
          position: { up: 50, left: 50, scale: 100 },
        },
      ],
      error: "",
      message: "",
      cards: null,
      cards_chunks: [],
      loading: false,
      profiles: null,
      errors: {},
      validated: true,
      cards_count: 2,
      cards_length: 0,
      horizontial: false,
      speed: false,
      duration: false,
      quota: false,
      price: false,
      profile: false,
      username_password: true,
      sessions: false,
      style: "",
      printing: false,
      default_elements: null,
      elements: {
        designer: "basic",
        count: 0,
        username: {
          label: this.$t("cards.username"),
          icon: "ti ti-user",
          visible: true,
          x: 50,
          y: 20,
          size: 12,
          color: "#000000",
        },
        password: {
          label: this.$t("cards.password"),
          icon: "ti ti-lock",
          visible: true,
          x: 50,
          y: 40,
          size: 12,
          color: "#000000",
        },
        network: {
          label: this.$t("batches.network"),
          icon: "ti ti-wifi",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        logo: {
          label: this.$t("batches.logo"),
          icon: "ti ti-photo",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
        },
        price: {
          label: this.$t("batches.price"),
          icon: "ti ti-currency-dollar",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        speed: {
          label: this.$t("batches.speed"),
          icon: "ti ti-rocket",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        expiration: {
          label: this.$t("batches.duration"),
          icon: "ti ti-hourglass",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        quota: {
          label: this.$t("batches.quota"),
          icon: "ti ti-chart-pie",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        profile: {
          label: this.$t("batches.profile"),
          icon: "ti ti-id-badge",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        sessions: {
          label: this.$t("batches.sessions"),
          icon: "ti ti-device-laptop",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        qr_code: {
          label: "QR Code",
          icon: "ti ti-qrcode",
          visible: false,
          url: "10.0.0.1",
          x: 50,
          y: 50,
          size: 100,
          color: "#000000",
        },
        phone_number: {
          label: this.$t("settings.phone_number"),
          icon: "ti ti-phone",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        status_url: {
          label: this.$t("settings.status_url"),
          icon: "ti ti-link",
          visible: false,
          x: 50,
          y: 50,
          size: 12,
          color: "#000000",
        },
        colors: {
          background: "#FFFFFF",
          boxes: "#66cfff",
          input: "#FFFFFF",
          border: "#666EE8",
          text_small: "#000000",
          text_big: "#000000",
        },
      },
      background: null,
      background_file: null,
      designs: null,
      design_id: -1,
      design_name: "",
      saving: false,
      pdfOptions: {
        margin: 5,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 1, dpi: 96, letterRendering: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
      exportFilename: "my-custom-file.pdf",
    };
  },
  computed: {
    ...mapGetters(["settings"]),
    cardStyle() {
      if (this.selectedCards === 1) {
        return {
          width: "100%",
          maxWidth: "1000px",
          aspectRatio: "1000 / 291",
        };
      } else if (this.selectedCards === 2) {
        return {
          width: "100%",
          maxWidth: "750px",
          aspectRatio: "750 / 291",
        };
      } else {
        return {
          width: "75%",
          maxWidth: "500px",
          aspectRatio: "500 / 291",
        };
      }
    },
  },
  inject: {
    server_url: {
      from: "server_url",
    },
  },
  async created() {
    this.loading = true;
    this.default_elements = this.elements;
    await this.fetchCard();
    this.loading = false;
    this.exportFilename = moment().format("YYYY-MM-DD, h-mma") + ".pdf";
    this.style = "top: 50%;";
    await this.fetchSavedValues();
  },
  methods: {
    toggleField(field) {
      if (field.active) {
        field.color = field.originalColor;
      } else {
        field.color = "#cccccc";
      }
    },
    setCards(number) {
      this.selectedCards = number;
      this.cards_count = number;
      this.updateChunks();
    },
    async fetchCard() {
      this.loading = true;
      this.cards = null;
      const response = await axios.get(
        `/cards/${this.$route.params.id}/cards?print=true`,
      );
      if (response.status == 200) {
        this.cards = response.data.data;
        this.cards_length = this.cards.length;
        this.cards_chunks = [];
        for (
          let index = 0;
          index < this.cards_length;
          index += 6 * this.cards_count
        ) {
          this.cards_chunks.push(
            this.cards.slice(index, index + 6 * this.cards_count),
          );
        }
        this.loading = false;
      }
    },
    updateChunks() {
      this.cards_chunks = [];
      for (
        let index = 0;
        index < this.cards_length;
        index += 6 * this.cards_count
      ) {
        this.cards_chunks.push(
          this.cards.slice(index, index + 6 * this.cards_count),
        );
      }
    },
    async store() {
      this.loading = true;
      var data = new FormData();
      data.append("id", this.design_id);
      data.append("name", this.design_name);
      data.append("elements", JSON.stringify(this.elements));
      data.append("card_image", this.background_file);
      const response = await axios.post("cards/design", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status == 200) {
        this.$router.push({
          query: { success: "success" },
        });
        this.saving = false;
        this.fetchSavedValues();
      }
      this.loading = false;
    },
    async saveDesignDialog() {
      const { value: designName } = await this.$swal.fire({
        title: this.$t("batches.enter_new_design_name"),
        input: "text",
        inputLabel: this.$t("batches.design_name"),
        inputValue: "Test1",
        showCancelButton: true,
        confirmButtonText: this.$t("control.save"),
        cancelButtonText: this.$t("control.cancel"),
        inputValidator: (value) => {
          if (!value) {
            return this.$t("batches.design_name_required");
          }
        },
      });
      if (designName) {
        this.design_name = designName;
        try {
          await this.store();
          this.$swal({
            icon: "success",
            title: this.$t("batches.new_design_saved"),
            timer: 1500,
            showConfirmButton: false,
          });
        } catch (error) {
          this.$swal({
            icon: "error",
            title: "Save Failed",
            text:
              "An error occurred while saving the design. Please try again.",
            confirmButtonText: this.$t("control.ok"),
          });
        }
      }
    },
    calculateSpeed(speed) {
      return speed > 1023 ? speed / 1024 + " Mb/s" : speed + " Kb/s";
    },
    calculateQuota(quota) {
      return quota > 1023 ? quota / 1024 + " GB" : quota + " MB";
    },
    calculateUnit(unit) {
      var result = "";
      switch (unit) {
        case "months":
          result = this.$t("profiles.unit.months");
          break;
        case "days":
          result = this.$t("profiles.unit.days");
          break;
        case "hours":
          result = this.$t("profiles.unit.hours");
          break;

        default:
          break;
      }
      return result;
    },
    validate() {},
    selectBackground() {
      this.background_file = this.$refs.imageFile.files.item(0);
      this.background = URL.createObjectURL(this.background_file);
    },
    async fetchSavedValues() {
      this.loading = true;
      const response = await axios.get("cards/designs");
      if (response.status == 200) {
        this.designs = response.data.data;
      }

      this.loading = false;
    },
    async selectDesign() {
      this.background_file = null;
      if (this.design_id < 1 || this.design_id == null) {
        this.elements = this.default_elements;
        this.design_name = "";
        this.background = null;
        return;
      }
      this.loading = true;
      var design;
      this.designs.forEach((element) => {
        if (element.id == this.design_id) design = element;
      });
      if (design.image_url)
        this.background = this.server_url + design.image_url;
      else this.background = null;
      var temp_elements = JSON.parse(design.elements);
      if (temp_elements.qr_code == null)
        temp_elements.qr_code = this.elements.qr_code;
      if (temp_elements.phone_number == null)
        temp_elements.phone_number = this.elements.phone_number;
      if (temp_elements.status_url == null)
        temp_elements.status_url = this.elements.status_url;
      this.elements = temp_elements;
      this.design_name = design.name;
      this.loading = false;
    },
    async print_element() {
      // Get HTML to print from element
      await print_element("print_page");
      // const prtHtml = document.getElementById("print_page").innerHTML;

      // // Get all stylesheets HTML
      // let stylesHtml = "";
      // for (const node of [
      //   ...document.querySelectorAll('link[rel="stylesheet"], style'),
      // ]) {
      //   stylesHtml += node.outerHTML;
      // }

      // // Open the print window
      // const WinPrint = window.open(
      //   "",
      //   "",
      //   "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      // );

      // WinPrint.document.write(`<!DOCTYPE html>
      // <html>
      //   <head>
      //     ${stylesHtml}
      //   </head>
      //   <body style="background-color: white;">
      //     ${prtHtml}
      //   </body>
      // </html>`);

      // WinPrint.document.close();
      // WinPrint.focus();
      // WinPrint.print();
    },
  },
};
</script>
<style scoped>
.times6 {
  height: 145.5px;
  width: 124.7px;
  font-size: 9pt;
}
.times5 {
  height: 145.5px;
  width: 149.64px;
  font-size: 9pt;
}
.times4 {
  height: 145.5px;
  width: 187.05px;
  font-size: 9pt;
}
.times3 {
  height: 145.5px;
  width: 249.4px;
  font-size: 9pt;
}
.times2 {
  height: 145.5px;
  width: 374.17px;
  font-size: 9pt;
}
.times1 {
  height: 145.5px;
  width: 748.2px;
  font-size: 9pt;
}
@media screen {
  .noPrint {
  }
  .noScreen {
    display: none;
  }
}

@media print {
  .noPrint {
    display: none;
  }
  .noScreen {
  }
}
</style>
